import React, { useEffect } from 'react';
import HeaderV2 from '../../components/v2/HeaderV2';
import FooterV2 from '../../components/v2/FooterV2';
import AuditFormV2 from '../../components/v2/AuditFormV2';
import useV2Language from '../../hooks/useV2Language';
import useDocumentLanguage from '../../hooks/useDocumentLanguage';
import '../../styles/v2/tokens.css';
import '../../styles/v2/landing.css';
import '../../styles/v2/audit.css';

const AuditV2 = () => {
  const { lang, setLang, buildHref } = useV2Language();
  useDocumentLanguage(lang);
  useEffect(() => {
    document.title = lang === 'es'
      ? 'Auditoría de Sistemas de Negocio — illumi.dev'
      : 'Business Systems Audit — illumi.dev';
  }, [lang]);
  return (
    <div className="illumi-v2" data-testid="illumi-v2-audit">
      <HeaderV2 language={lang} onLanguageChange={setLang} buildHref={buildHref} />
      <main><AuditFormV2 lang={lang} /></main>
      <FooterV2 language={lang} buildHref={buildHref} />
    </div>
  );
};
export default AuditV2;
